<ng-container
  [ngTemplateOutlet]="contentTemplate"
  *ngIf="loadContent"></ng-container>
